/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Privacy_DescriptionInputs */

const en_meta_privacy_description = /** @type {(inputs: Meta_Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn how Lindevo collects, uses, and protects your personal data. GDPR-compliant privacy policy covering analytics, cookies, and third-party services.`)
};

const lv_meta_privacy_description = /** @type {(inputs: Meta_Privacy_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzziniet, kā Lindevo apkopo, izmanto un aizsargā Jūsu personas datus. GDPR saderīga privātuma politika: analītika, sīkdatnes un trešo pušu pakalpojumi.`)
};

/**
* | output |
* | --- |
* | "Learn how Lindevo collects, uses, and protects your personal data. GDPR-compliant privacy policy covering analytics, cookies, and third-party services." |
*
* @param {Meta_Privacy_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_privacy_description = /** @type {((inputs?: Meta_Privacy_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Privacy_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_privacy_description(inputs)
	return en_meta_privacy_description(inputs)
});